import { SeuilModel } from './../models/simple-types/seuil.model';
import { Ca1Model } from 'src/app/shared/models/societe-linked/ca1.model';
import { Injectable } from '@angular/core';

@Injectable()
export class Ca1ModelDTO {
  public ca1: Ca1Model;
  public seuil: SeuilModel;
}
